module.exports = __webpack_public_path__ + "static/media/insulation_gwp_60y_n.348a8e19.csv";